import { types } from './transrecenciaentrecontas.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'transferenciaEntreContas',
  columns: [],
  currentRecord: {
    unidadeOrigem: '',
    grupoOrigem: '',
    formaPagamentoOrigem: '',
    contaCorrenteOrigem: '',
    unidadeDestino: '',
    grupoDestino: '',
    formaPagamentoDestino: '',
    contaCorrenteDestino: '',
    dataPagamento: new Date(),
    valor: '',
  },
  messages: null,
  selectedFilters: [],
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDTransferenciaEntreContasReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('transferenciaentrecontas')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    default:
      return state
  }
  return state
}

function reset(state, action) {
  return {
    ...state,
    currentRecord: initialState.currentRecord,
  }
}
